import FormField from "../form-field";

export default class ButtonsField extends FormField {
	constructor(props) {
		super(props);

		this.$buttons = null;
		this.value = null;

		this.init();
	}

	init() {
		this.$root = this.props.$root;

		if (!this.$root) {
			throw new Error('ButtonsInput: Root element is not defined!');
		}

		this.$buttons = this.$root.querySelectorAll('button');

		if (!this.$buttons.length) {
			throw new Error('ButtonsInput: Buttons missing');
		}

		super.init();
	}

	addEventListeners() {
		this.$buttons.forEach(($button) => {
			$button.addEventListener('click', (e) => {
				if ($button.classList.contains('-active')) {
					return;
				}

				this.unselectAll();
				this.setValue($button.dataset.value);
				$button.classList.add('-active');
				this.validateSoft();
			});
		});
	}

	setValue(value) {
		if (value === 'true') {
			value = true;
		} else if (value === 'false') {
			value = false;
		}

		super.setValue(value);
	}

	unselectAll() {
		this.$buttons.forEach(($button) => {
			$button.classList.remove('-active');
		});
	}

	validate() {
		this.isValid = !!this.value || this.value === false;
	}

	setInitialState() {
		this.setValue(null);
		this.unselectAll();
	}
}